import { store } from "@/store/store";
import Vue from "vue";
import VueRouter, { Route } from "vue-router";
import routes from "./routes";
import { ActionTypes } from "@/store/modules/Auth/actions-types";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to: Route, _from: Route, next: any) => {
  await store.dispatch(ActionTypes.VERIFY_AUTH);
  const route_requiring_auth: boolean = to?.meta?.requiresAuth;
  if (route_requiring_auth && store.getters.IS_LOGGED_IN) next();
  else if (!route_requiring_auth && store.getters.IS_LOGGED_IN) next({ path: "/dashboard" });
  if (route_requiring_auth && !store.getters.IS_LOGGED_IN) next({ path: "/" });
  else next();
});

router.afterEach((to: Route) => {
  Vue.nextTick(() => {
    document.title = to?.meta?.title ? to.meta.title : process.env.VUE_APP_NAME;
  });
});

export default router;
